import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_lab_details, save_lab_details } from './api';
import type { LabDetailsRequest } from './types';

const KEY = ['module-details', 'lab'] as const;

export function use_save_lab_details() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: LabDetailsRequest) => save_lab_details(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['onboarding', 'draft'] });
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function use_lab_details(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY,
    queryFn: fetch_lab_details,
    staleTime: 0,
    retry: 0,
    enabled: options?.enabled ?? true,
  });
}
